<app-widget-process-step-group-list [autoFocusSearch]="false"></app-widget-process-step-group-list>